import { render, staticRenderFns } from "./StatisticsPieCardProducts.vue?vue&type=template&id=219beb61&"
import script from "./StatisticsPieCardProducts.vue?vue&type=script&lang=js&"
export * from "./StatisticsPieCardProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports